import { render, staticRenderFns } from "./SampleMutation.vue?vue&type=template&id=5057e6ae&scoped=true&"
import script from "./SampleMutation.vue?vue&type=script&lang=js&"
export * from "./SampleMutation.vue?vue&type=script&lang=js&"
import style0 from "./SampleMutation.vue?vue&type=style&index=0&id=5057e6ae&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5057e6ae",
  null
  
)

export default component.exports